<template>
  <div class="cancel-container">
    <div class="card">
      <div style="margin-bottom: 1.5rem;">
        <img v-if="estado === 'ok'" src="https://cdn-icons-png.flaticon.com/512/845/845646.png" alt="Acción correcta" class="cancel-image"/>
        <img v-else-if="estado !== 'loading'" src="https://cdn-icons-png.flaticon.com/512/463/463612.png" alt="Acción fallida" class="cancel-image"/>
      </div>
      <div class="message">
        <p v-if="estado === 'ok' && action === 'cancel'">Tu pedido ha sido cancelado con éxito.</p>
        <p v-if="estado === 'ok' && action === 'confirm'">Tu pedido ha sido confirmado correctamente.</p>
        <p v-if="estado === 'ok'">Recibirás un correo confirmando la {{ action === 'cancel' ? 'cancelación' : 'confirmación' }}.</p>

        <p v-else-if="estado === 'ya_procesado' || estado === 'ya_cancelado'">
          Este pedido ya fue {{ action === 'cancel' ? 'cancelado' : 'confirmado' }} anteriormente o ha expirado el tiempo disponible.
        </p>
        <p v-else-if="estado === 'en_curso'">
          Este pedido está en curso, ponte en contacto con el restaurante.
        </p>
        <p v-else-if="estado === 'error'">
          Ha ocurrido un error al {{ action === 'cancel' ? 'cancelar' : 'confirmar' }} tu pedido.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'ClientOrderAction',
    data() {
      return {
        estado: 'loading',
        action: 'cancel',
      };
    },
    async mounted() {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('id');
      const action = params.get('action') || 'cancel';
      this.action = action;

      const url = process.env.VUE_APP_API_URL + '/v1/api/app/ClientUpdateOrder?token=' + token + '&action=' + action;

      try {
        const response = await axios.put(url);
        if (response.status === 200) {
          this.estado = 'ok';
        } else {
          this.estado = 'error';
        }
      } catch (error) {
        console.log(error.response.status)
        if (error.response && error.response.status === 412) {
            this.estado = 'ya_cancelado';
        } else if (error.response && error.response.status === 413) {
          this.estado = 'en_curso';
        }else {
          this.estado = 'error';
        }
      }
    }
  };
</script>

<style scoped>
  .cancel-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #fdd1a7, var(--primary-color));
    padding: 1rem;
    font-family: 'Roboto', sans-serif;
  }

  .card {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    padding: 2.5rem;
    text-align: center;
    max-width: 400px;
    width: 90%;
    animation: fadeIn 0.8s ease-out;
  }

  .cancel-image {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>